import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { StoreShippingType } from 'types/storeShipping'

const updateDeliveryStatus = (trackingNumber: string, storeShippingRef: FirebaseDocRefType) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const now = FirebaseTimestamp.now()
    const value: Pick<StoreShippingType, 'shipped_at' | 'status' | 'tracking_number' | 'updated_at'> = {
      shipped_at: now,
      status: 'shipped',
      tracking_number: trackingNumber,
      updated_at: now,
    }
    await storeShippingRef.update(value)
    dispatch(hideLoadingAction())
  }
}

export default updateDeliveryStatus
